<template>
  <div>
    <v-sheet
      v-show="gateReportStore.showControls"
      v-resize-observer="onContentResized"
      class="tabs z-index-0"
    >
      <v-tabs height="35">
        <v-tab v-for="tab in visibleTabs" :key="tab.to" :to="tab.to" nuxt>
          {{ tab.label }}
        </v-tab>
      </v-tabs>
    </v-sheet>

    <portal-target name="hovered-thumbnails-container" />

    <NuxtChild
      ref="content"
      v-resize-observer="onContentResized"
      :style="contentStyle"
    />
  </div>
</template>

<script>
import { useGateReportStore } from "@/stores/gateReport"
import { mapStores } from "pinia"
import { ProjectFeatureFlag } from "@evercam/shared/types"
import { PERMISSIONS } from "@/constants/permissions"

export default {
  meta: {
    requiredPermissions: [PERMISSIONS.GATE_REPORT.VIEW],
  },
  name: "GateReportCamera",
  async asyncData({ route, params, redirect }) {
    if (
      !useGateReportStore().selectedProject ||
      useGateReportStore().selectedProject?.exid !== params.exid
    ) {
      await useGateReportStore().init(params.exid)
    }

    const isAnprBasedProject =
      useGateReportStore().selectedProject?.featureFlags?.includes(
        ProjectFeatureFlag.GateReportAnprBased
      ) || false

    const baseRoute = `/gate-report/${params.report}/${params.exid}`

    if (route.name === "gate-report-report-exid") {
      return redirect(`${baseRoute}/${isAnprBasedProject ? "anpr" : "events"}`)
    }

    return {
      isAnprBasedProject,
    }
  },
  data() {
    return {
      contentStyle: {},
    }
  },
  computed: {
    ...mapStores(useGateReportStore),
    baseRoute() {
      return `/gate-report/${this.$route.params.report}/${this.$route.params.exid}`
    },
    visibleTabs() {
      const tabs = [
        {
          label: "ANPR",
          to: `${this.baseRoute}/anpr`,
          visible: this.isAnprBasedProject,
        },
        { label: "Events", to: `${this.baseRoute}/events` },
        { label: "ROI", to: `${this.baseRoute}/roi` },
        { label: "Parameters", to: `${this.baseRoute}/params` },
        { label: "Logs", to: `${this.baseRoute}/logs-history` },
      ]

      return tabs.filter((tab) => tab.visible !== false)
    },
  },
  created() {
    this.$root.$on("expand-event-table", (showControls) => {
      this.showTabs = showControls
    })
  },
  methods: {
    onContentResized() {
      this.$setTimeout(() => {
        const content = this.$refs?.content?.$el?.getBoundingClientRect()
        this.contentStyle = {
          height: `${window.innerHeight - content?.top || 0}px !important`,
        }
      }, 500)
    },
  },
}
</script>

<style scoped>
.tabs {
  position: relative;
  z-index: 99;
  box-shadow: 0 14px 10px -14px #0000002e;
}
</style>
